module.exports = __webpack_public_path__ + "img/small-2.88180bf4.jpg";